import { getOutreachMessageOutlookLink } from '@/services/OutreachDraft'

// Opens a thread message in Outlook on the web. The link is looked up on
// click (it changes whenever the message moves folders), so the tab is
// opened first, while the click still counts as a user gesture, and pointed
// at the link once it arrives -- a tab opened after the await is blocked as a
// popup. Returns an error message, or null.
export async function openInOutlook(messageId, token) {
  const tab = window.open('', '_blank')
  try {
    const { url } = await getOutreachMessageOutlookLink(messageId, token)
    if (tab) {
      tab.opener = null
      tab.location.href = url
    } else {
      window.open(url, '_blank', 'noopener')
    }
    return null
  } catch (e) {
    if (tab) tab.close()
    return e?.response?.data?.detail || 'Could not open this email in Outlook'
  }
}
